// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2bZze","fileBtn":"File_fileBtn__3430i","closeBtn":"File_closeBtn__IALrw","fileSelected":"File_fileSelected__20DXe","disabled":"File_disabled__BwLV9"};